import { toBoolean } from "./misc";

export const CONCIERGE_PAGE_FLAGS = {
  dashboard: "conciergeDashboardEnabled",
  offsite: "conciergeOffsiteTicketsEnabled",
  vipRouting: "conciergeVipRoutingEnabled",
  vipAlerts: "conciergeVipAlertLogsEnabled",
  vipBooking: "conciergeVipBookingEnabled",
  shifts: "conciergeShiftsEnabled",
  porters: "conciergeShiftsEnabled",
  parkingAudit: "conciergeParkingAuditEnabled",
};

export const CONCIERGE_ACCESS_FLAGS = [
  "conciergeModuleEnabled",
  "conciergeDashboardEnabled",
  "conciergeOffsiteTicketsEnabled",
  "conciergeVipRoutingEnabled",
  "conciergeVipAlertLogsEnabled",
  "conciergeVipBookingEnabled",
  "conciergeShiftsEnabled",
  "conciergeParkingAuditEnabled",
];

export const VEHICLE_PHOTO_MODES = {
  OPTIONAL: "optional",
  REQUIRED: "required",
  DISABLED: "disabled",
};

function parseConfiguration(configuration) {
  if (!configuration) return null;

  if (typeof configuration === "string") {
    try {
      return JSON.parse(configuration);
    } catch {
      return null;
    }
  }

  if (typeof configuration === "object") return configuration;

  return null;
}

export function getConciergeConfigurationRecord(facility) {
  return facility?.featureFacilityProviderConfigurations?.find(
    (item) => item?.feature?.name === "CONCIERGE",
  );
}

export function getConciergeConfiguration(facility) {
  const config = getConciergeConfigurationRecord(facility);
  const configuration = parseConfiguration(config?.configuration);

  if (!configuration || Object.keys(configuration).length === 0) return null;

  return configuration;
}

export function getRunnerVehiclePhotoMode(facility) {
  const mode = getConciergeConfiguration(facility)?.runnerVehiclePhotosMode;

  return Object.values(VEHICLE_PHOTO_MODES).includes(mode)
    ? mode
    : VEHICLE_PHOTO_MODES.OPTIONAL;
}

export function isAnprCameraEnabled(facility) {
  const enabled = getConciergeConfiguration(facility)?.anprEnabled;

  return enabled == null ? true : toBoolean(enabled);
}

export function areGuestVehicleStatusAlertsEnabled(facility) {
  return toBoolean(
    getConciergeConfiguration(facility)?.guestVehicleStatusAlertsEnabled,
  );
}

export function getUnassignedPickupAlertSettings(facility) {
  const configuration = getConciergeConfiguration(facility) || {};
  const minutes = Number(configuration.unassignedPickupAlertMinutes);
  const userIds = configuration.unassignedPickupAlertUserIds;

  return {
    minutes: Number.isInteger(minutes) && minutes >= 0 ? minutes : 15,
    userIds: Array.isArray(userIds) ? userIds.filter(Boolean) : [],
  };
}

export function isConciergeModuleEnabled(facility) {
  const configuration = getConciergeConfiguration(facility);

  return toBoolean(configuration?.conciergeModuleEnabled);
}

export function isConciergePageEnabled(facility, page) {
  const configuration = getConciergeConfiguration(facility);
  const flag = CONCIERGE_PAGE_FLAGS[page];

  return isConciergeModuleEnabled(facility) && toBoolean(configuration?.[flag]);
}

/* vipBooking is reached from an alert, and offsite tickets are folded into the
 * dashboard - neither is a page the console navigates to on its own. */
const UNLISTED_CONCIERGE_PAGES = ["vipBooking", "offsite"];

export function getEnabledConciergePages(facility) {
  return Object.keys(CONCIERGE_PAGE_FLAGS)
    .filter((page) => !UNLISTED_CONCIERGE_PAGES.includes(page))
    .filter((page) => isConciergePageEnabled(facility, page));
}
